module.exports = __webpack_public_path__ + "img/box_pro_seven_5.e9312547.jpg";